export default () => {
  return new Promise((resolve): void => {
    requestAnimationFrame(() => {
      setTimeout(resolve, 0)
    })
  })
}
